import React, { Component } from "react";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import Typography from "@material-ui/core/Typography";

const calculateColor = (value) => {
  let color = "#000";
  if (value < 0) {
    color = red[400];
  }
  return color;
};

const calculatePercentageColor = (value) => {
  let color = "#000";
  return color;
};

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

const formatNumber = (number) =>
  formatter.format(Math.round(parseFloat(number))).replace("$", "");

const styles = (theme) => ({
  gridRoot: {
    flexGrow: 1,
    marginTop: 30,
  },
  tile: {
    position: "inherit",
  },
  paper: {
    padding: 15,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  cellValue: {
    fontSize: 12,
    paddingRight: 5,
  },
  footerRow: {
    backgroundColor: "#ccc",
  },
  footerCell: {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#ccc",
  },
});

class PlayerAnalysisResult extends Component {
  render() {
    const { analysisData, reasonVoid, classes } = this.props;
    return (
      <div style={{ width: "100%" }}>
        {analysisData.length === 0 && (
          <Paper className={classes.paper}>
            <h3>{reasonVoid}</h3>
          </Paper>
        )}
        {analysisData.map((analysis) => {
          const timeKeys = Object.keys(analysis.Time);
          return (
            <div>
              <h1>{analysis.Operation}</h1>
              <div className={classes.gridRoot}>
                <GridList cols={timeKeys.length}>
                  {timeKeys.map((timeKey, i) => {
                    const analysisTable = analysis.Time[timeKey];
                    const NumberOfWagersTotal = _.sumBy(
                      analysisTable,
                      "NumberOfWagers"
                    );
                    const VolumeTotal = _.sumBy(analysisTable, "Volume");
                    const EarningsTotal = _.sumBy(analysisTable, "Earnings");
                    const HoldTotal = (
                      (EarningsTotal * 100) /
                      VolumeTotal
                    ).toFixed(2);
                    return (
                      <GridListTile
                        classes={{ tile: classes.tile }}
                        style={{ height: "auto", backgroundColor: "#FFF" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h3 style={{ textAlign: "left" }}>
                            {analysisTable[0].TimeName}
                          </h3>
                          <Tooltip
                            enterTouchDelay={0}
                            placement="top-start"
                            title={
                              <React.Fragment>
                                <Typography>
                                  A negative hold % means players LOST money and
                                  you HELD that money. A positive number means
                                  the players WON money and you LOST money.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <IconButton
                              className={classes.button}
                              aria-label="Delete"
                            >
                              <InfoIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <Table>
                          <TableHead>
                            <TableRow>
                              {i === 0 && (
                                <TableCell padding="none">Category</TableCell>
                              )}
                              <TableCell padding="none">Count</TableCell>
                              <TableCell padding="none">Volume</TableCell>
                              <TableCell padding="none">Win/Loss</TableCell>
                              <TableCell padding="none">Hold</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {analysisTable.map((analysisRow, rowIndex) => {
                              return (
                                <TableRow
                                  style={{
                                    backgroundColor:
                                      rowIndex % 2 ? "#FFF" : "#DDD",
                                  }}
                                  key={`${analysis.Operation}${timeKey}${analysisRow.IdPlayer}`}
                                >
                                  {i === 0 && (
                                    <TableCell
                                      padding="none"
                                      className={classes.cellValue}
                                    >
                                      {analysisRow.Title}
                                    </TableCell>
                                  )}
                                  <TableCell
                                    align="right"
                                    padding="none"
                                    className={classes.cellValue}
                                    style={{
                                      color: calculateColor(
                                        analysisRow.NumberOfWagers
                                      ),
                                    }}
                                  >
                                    {analysisRow.NumberOfWagers}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    padding="none"
                                    className={classes.cellValue}
                                    style={{
                                      color: calculateColor(analysisRow.Volume),
                                    }}
                                  >
                                    {formatNumber(analysisRow.Volume)}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    padding="none"
                                    className={classes.cellValue}
                                    style={{
                                      color: calculateColor(
                                        analysisRow.Earnings
                                      ),
                                    }}
                                  >
                                    {formatNumber(analysisRow.Earnings)}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    padding="none"
                                    className={classes.cellValue}
                                    style={{
                                      borderRight: "2px solid #000",
                                      color: calculatePercentageColor(
                                        analysisRow.Hold
                                      ),
                                    }}
                                  >
                                    {analysisRow.Hold} %
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                          <TableFooter>
                            <TableRow
                              style={{
                                backgroundColor: "#CCC",
                              }}
                            >
                              {i === 0 && (
                                <TableCell
                                  className={classes.cellValue}
                                  style={{
                                    color: "#000",
                                    fontWeight: "bold",
                                  }}
                                  padding="none"
                                >
                                  TOTAL
                                </TableCell>
                              )}
                              <TableCell
                                align="right"
                                className={classes.cellValue}
                                padding="none"
                                style={{
                                  fontWeight: "bold",
                                  color: calculateColor(NumberOfWagersTotal),
                                }}
                              >
                                {NumberOfWagersTotal}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.cellValue}
                                padding="none"
                                style={{
                                  fontWeight: "bold",
                                  color: calculateColor(VolumeTotal),
                                }}
                              >
                                {formatNumber(VolumeTotal)}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.cellValue}
                                padding="none"
                                style={{
                                  fontWeight: "bold",
                                  color: calculateColor(EarningsTotal),
                                }}
                              >
                                {formatNumber(EarningsTotal)}
                              </TableCell>
                              <TableCell
                                align="right"
                                className={classes.cellValue}
                                padding="none"
                                style={{
                                  fontWeight: "bold",
                                  borderRight: "2px solid #000",
                                  color: calculatePercentageColor(HoldTotal),
                                }}
                              >
                                {HoldTotal}%
                              </TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </GridListTile>
                    );
                  })}
                </GridList>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

PlayerAnalysisResult.propTypes = {
  analysisData: PropTypes.array.isRequired,
  reasonVoid: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(PlayerAnalysisResult);
